import React from 'react'

import { DateTimeNow } from '../../../utils/dates'

export const AlertMessage = ({ title, text, type, close = () => {}, hiddenClose = false, hiddenTime = false }) => {
  let color

  switch (type) {
    case 'error':
      color = 'is-danger'
      break
    case 'success':
      color = 'is-success'
      break
    case 'alert':
      color = 'is-warning'
      break
    default:
      color = 'is-light'
      break
  }

  return (
    <article className={`message mb-3 ${color} has-background-white`}>
      <div className="message-body" style={{ position: 'relative', paddingRight: '2.5rem' }}>
        {!hiddenClose ? (
          <button className="delete" style={{ position: 'absolute', right: 15, top: 15 }} onClick={close} />
        ) : null}

        <strong style={{ display: 'block', wordWrap: 'break-word' }}>{title}</strong>
        <p style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>{text}</p>
        {!hiddenTime ? <div className="has-text-right is-size-7">{DateTimeNow()}</div> : null}
      </div>
      <progress className={`progress ${color}`} style={{ height: 5, marginTop: -5 }} />
    </article>
  )
}
